import { createContext } from 'react';

const ErrorContext = createContext(null);

export default ErrorContext;
